export function getPreviousIndex(currentIndex: number, length: number) {
  return (((currentIndex - 1) % length) + length) % length;
}
